const actionPanelButtonsConstantsEN = {
  createActionPanel: 'Create',
  backActionPanel: 'Back',
};

export default actionPanelButtonsConstantsEN;
